<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {

}
</script>


<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

html {
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.75;
  @media (min-width: $laptop-s) {
    font-size: 18px;
  }
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  color: $dark-grey;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

ol,
ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

button {
  border: none;
  margin: 0;
  padding: 0;
  background: transparent;

  &:focus {
    outline: none;
  }
}

input,
button {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.wrapper {
  max-width: $wrapper;
  margin: 0 auto;
}

.container {
  padding: 0 15px;
}

.underlined-text {
  position: relative;
  border-bottom: 0.2em solid $lipstick;
  display: inline-block;
  line-height: 0.5em;
  &.underlined-text--light-gold {
    border-color: $light-gold;
  }
}

.btn {
  display: inline-block;
  text-align: center;
  text-decoration: none;
  color: #fff;
  padding: 8px 0;
  width: 290px;
  background: $lipstick;
  font-size: 1.25em;
  font-weight: 500;
  border: none;
}
.btn--white {
  background: white;
  color: $lipstick;
}

.text {
  p {
    margin-bottom: 1em;
  }
}

.hide {
  position: absolute !important;
  top: -9999px !important;
  left: -9999px !important;
}

.rte {
  p {
    margin-bottom: 1em;
  }
}

a {
  color: inherit;
  text-decoration: none;
}

.inline-inputs {
  @media (min-width: $tablet) {
    display: flex;
    input {
      margin: 0 10px;
      &:first-of-type {
        margin-left: 0;
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}

.input-btn {
  @extend .group;
}

.input-btn__text,
.input-btn__submit {
  float: left;
  height: 100%;
  display: inline-block;
  border: none;
  padding: 1em 0.75em;
  color: white;
  font-size: 0.8em;
}

.input-btn__text {
  background: $slate-grey;
  border: none;
  min-width: 200px;
  &::placeholder {
    color: white;
    opacity: 0.5;
  }
}

.input-btn__submit {
  background: $lipstick;
  padding-left: 1.5em;
  padding-right: 1.5em;
}

.no-scroll {
  overflow: hidden;
}

// Transitions
.fade-enter-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
